import React from 'react';
import { AppRouter } from './config/AppRouter';
import { CookiesProvider } from './providers/CookiesProvider';
import { CookiesWarning } from './components/Common/CookiesWarning';

function App() {
  return (
    <>
      <CookiesProvider>
        <AppRouter />
        <CookiesWarning />
      </CookiesProvider>
    </>
  );
}

export default App;